import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  api,
  errorMessage,
  formatDate,
  formatMoney,
  DetailRow,
} from "./assetsShared";
import "./Assets.css";

export default function HardwareDestroyed() {
  const navigate = useNavigate();

  const [hardware, setHardware] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        setError("");
        const res = await api.get("/hardware/destroyed");
        setHardware(res.data || []);
      } catch (requestError) {
        setError(errorMessage(requestError, "Unable to load destroyed hardware."));
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return (
    <div className="as-page">
      <div className="as-header">
        <h2>🗑 Destroyed Hardware</h2>

        <button
          type="button"
          className="as-btn as-btn-secondary"
          onClick={() => navigate("/hardware")}
        >
          ← Back to Hardware Master
        </button>
      </div>

      {error && <div className="as-alert">{error}</div>}

      {loading && <div className="as-empty">Loading...</div>}

      {!loading && !hardware.length && !error && (
        <div className="as-empty">No destroyed hardware.</div>
      )}

      <div className="as-detail-grid">
        {hardware.map((h) => {
          // destroy history entry
          const destroyed = h.history?.find((x) => x.action === "DESTROYED");

          return (
            <div key={h._id} className="as-detail-card destroyed">
              <h4 className="as-detail-title">{h.type}</h4>

              <p className="as-detail-subtitle">
                {h.productBrand} – {h.pcName}
              </p>

              <DetailRow label="Type" value={h.type} />
              <DetailRow label="Brand" value={h.productBrand} />
              <DetailRow label="Connection Type" value={h.connectionType} />
              <DetailRow label="Serial No" value={h.serialNo} />
              <DetailRow label="Location" value={h.location} />
              <DetailRow label="Invoice No" value={h.invoiceNo} />
              <DetailRow label="IP Address" value={h.ipAddress} />
              <DetailRow label="Vendor Name" value={h.vendorName} />
              <DetailRow label="Vendor Contact" value={h.vendorContactNo} />
              <DetailRow label="Vendor Email" value={h.vendorEmail} />
              <DetailRow
                label="Purchase Value"
                value={formatMoney(h.purchaseValue)}
              />
              <DetailRow
                label="Purchase Date"
                value={formatDate(h.purchaseDate)}
              />

              <DetailRow
                label="Assigned To (Before Destroy)"
                value={
                  destroyed?.assignedUser
                    ? destroyed.assignedUser.name
                    : "IN STOCK"
                }
              />

              <DetailRow
                label="Destroyed On"
                value={formatDate(destroyed?.date || h.destroyedAt)}
              />

              <DetailRow label="Destroy Reason" value={destroyed?.note} />
              <DetailRow label="Status" value="DESTROYED" />
            </div>
          );
        })}
      </div>
    </div>
  );
}